<footer class="mdc-layout-grid__inner" *ngIf="viewport.showFooter">
	<div class="mdc-layout-grid__cell--span-12 text-center section">
		<div class="three_col">
			<div class="col_one" [ngClass]="{ mobile: viewport.type === 'mobile' }">
				<span class="header n126">{{ locale.translations['help']['n126'] }}</span>

				<a [href]="'/' + locale.getLocale() + '/help'" class="n151">
					<mat-icon class="mat-icon-rtl-mirror">link</mat-icon>
					&nbsp;

					<span>{{ locale.translations['footer']['n151'] }}</span>
				</a>
				<br />

				<a [href]="'/' + locale.getLocale() + '/vip-plus'" class="n201">
					<mat-icon class="mat-icon-rtl-mirror">link</mat-icon>
					&nbsp;

					<span>{{ locale.translations['n723'] }}</span>
				</a>
				<br />

				<a [href]="'/' + locale.getLocale() + '/campaign'">
					<mat-icon class="mat-icon-rtl-mirror">link</mat-icon>
					&nbsp;

					<span>{{ locale.translations['help']['campaign']['n254'] }}</span>
				</a>
				<br />

				<a [href]="'/' + locale.getLocale() + '/customer-feedback'">
					<mat-icon class="mat-icon-rtl-mirror">link</mat-icon>
					&nbsp;

					<span>{{ locale.translations['n735'] }}</span>
				</a>
				<br />

				<!-- <a [routerLink]="['/barcode-scanner']" class="n151">
					<mat-icon class="mat-icon-rtl-mirror">link</mat-icon>
					&nbsp;

					<span>{{ locale.translations['ads']['qrcode']['n410'] }}</span>
				</a> -->
				<br />
			</div>

			<!--Quick links column-->
			<div class="col_one" [ngClass]="{ mobile: viewport.type === 'mobile' }">
				<span class="header n126">{{ locale.translations['footer']['n405'] }}</span>

				<a [href]="'/' + locale.getLocale() + '/about'"class="n151">
					<mat-icon class="mat-icon-rtl-mirror">link</mat-icon>
					&nbsp;

					<span>{{ locale.translations['aboutus']['n394'] }}</span>
				</a>
				<br />

				<a [href]="'/' + locale.getLocale() + '/privacy-policy'" class="n151">
					<mat-icon class="mat-icon-rtl-mirror">link</mat-icon>
					&nbsp;

					<span>{{ locale.translations['footer']['n406'] }}</span>
				</a>
				<br />

				<a [href]="'/' + locale.getLocale() + '/cookie-policy'" class="n151">
					<mat-icon class="mat-icon-rtl-mirror">link</mat-icon>
					&nbsp;

					<span>{{ locale.translations['footer']['n488'] }}</span>
				</a>
				<br />

				<a [href]="'/' + locale.getLocale() + '/terms'" class="n151">
					<mat-icon class="mat-icon-rtl-mirror">link</mat-icon>
					&nbsp;

					<span>{{ locale.translations['footer']['n489'] }}</span>
				</a>
				<br />
			</div>
			<!--end of quick links columm-->

			<div class="col_one" [ngClass]="{ mobile: viewport.type === 'mobile' }">
				<span class="header n154">{{ locale.translations['footer']['n154'] }}</span>

				<a (click)="onCallHelpline(07512347071)" class="n103">
					<mat-icon class="mat-icon-rtl-mirror">call</mat-icon>
					&nbsp;

					<span>{{ locale.translations['premium']['n103'] }}</span>
				</a>
				<br />

				<a (click)="onCallHelpline(07706921858)" class="n104">
					<mat-icon class="mat-icon-rtl-mirror">call</mat-icon>
					&nbsp;

					<span>{{ locale.translations['premium']['n104'] }}</span>
				</a>
				<br />

				<a href="javascript:void(0)" class="n104">
					<mat-icon class="mat-icon-rtl-mirror">access_time</mat-icon>
					&nbsp;

					<span>{{ locale.translations['ads']['qrcode']['n412'] }}</span>
				</a>
			</div>

			<div class="col_one" [ngClass]="{ mobile: viewport.type === 'mobile' }">
				<span class="header n152">{{ locale.translations['footer']['n152'] }}</span>

				<a href="https://itunes.apple.com/us/app/kurdshopping-kurdistan/id537659933" target="_blank" class="n15">
					<i class="fab fa-apple"></i>
					&nbsp;

					{{ locale.translations['footer']['n15'] }}
				</a>
				<br />

				<a
					href="https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.opaxlabs.kurdshopping&ddl=1&pcampaignid=web_ddl_1"
					target="_blank"
					class="n16"
				>
					<i class="fab fa-android"></i>
					&nbsp;

					{{ locale.translations['footer']['n16'] }}
				</a>
				<br />

				<a href="https://appgallery.huawei.com/#/app/C100966239" target="_blank" class="n291">
					<img [src]="'/assets/favicon/huawei_icon.png' | s3Image" width="12px" style="opacity: 0.8" />
					&nbsp;
					{{ locale.translations['footer']['n291'] }}
				</a>
			</div>
		</div>
	</div>

	<div class="mdc-layout-grid__cell--span-12 text-center section">
		<span class="header n153 text-center">{{ locale.translations['footer']['n153'] }}</span>

		<a href="https://www.facebook.com/KurdShoppingKurdistan" target="_blank" class="n12 pr-3">
			<img [src]="'/assets/favicon/Group 45652.svg' | s3Image" class="sizer" title="{{ locale.translations['footer']['n12'] }}" />
		</a>

		<a href="https://www.instagram.com/kurdshopping.cars/" target="_blank" class="n14 pr-3">
			<img [src]="'/assets/favicon/Group 45653.svg' | s3Image" class="sizer" title="{{ locale.translations['footer']['n14'] }}" />
		</a>

		<a href="https://www.tiktok.com/@kurdshoppingiraq" target="_blank" class="n292 pr-3">
			<img [src]="'/assets/favicon/tiktok.svg' | s3Image" title="{{ locale.translations['footer']['n292'] }}" class="sizer" />
			&nbsp;
		</a>

		<a href="https://www.snapchat.com/add/kurdshopping1" target="_blank" class="n293 pr-3">
			<img [src]="'/assets/favicon/Group 45640.svg' | s3Image" title="{{ locale.translations['footer']['n293'] }}" class="sizer" />
			&nbsp;
		</a>

		<a href="https://invite.viber.com/?g2=AQBsdf%2FwL70GN05uiUdrXk9Pis7j3AoW3KXrsA8ZZ7tJ%2FJqifSqBynv1Vq7%2FPilN" target="_blank" class="n294 pr-3">
			<img [src]="'/assets/favicon/viber.svg' | s3Image" title="{{ locale.translations['footer']['n294'] }}" class="sizer" />
			&nbsp;
		</a>

		<a href="https://www.facebook.com/groups/488922098405997" target="_blank" class="n296 pr-3">
			<img [src]="'/assets/favicon/group.svg' | s3Image" class="sizer" title="{{ locale.translations['footer']['n296'] }}" />
			&nbsp;
		</a>

		<a href="https://t.me/ksbuysell" target="_blank" class="n295 pr-3">
			<img [src]="'/assets/favicon/telegram.svg' | s3Image" title="{{ locale.translations['footer']['n295'] }}" class="sizer" />
			&nbsp;
		</a>

		<a
			href="https://www.youtube.com/channel/UCq-QrWeIQAq3rmR89VhYoQQ"
			title="{{ locale.translations['footer']['n301'] }}"
			target="_blank"
			class="n301 pr-3"
		>
			<img [src]="'/assets/favicon/Group 45643.svg' | s3Image" class="sizer" />
		</a>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<mat-divider></mat-divider>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<span class="copyright" dir="ltr">&copy; © {{year}} Kurd Shopping – All Rights Reserved</span>

		<span class="copyright" dir="ltr">
			Developed by
			<a href="https://devcentrehouse.eu" target="_blank">Dev Centre House (Ireland)</a>
		</span>
	</div>
</footer>
